import React, {Fragment, useContext} from "react";
import {observer} from "mobx-react-lite";
import {Store} from "../stores/store-root";
import NewWindow from "react-new-window";

const NonModalContainer = () => {
    const root = useContext(Store);
    const {
        modal: {open, body},
        closeModal,
    } = root.Window;

    const onUnload = ()=>{
        root.Window.closeModal();
    }
    return (
        <Fragment>
            {(open) ? (<NewWindow onUnload={onUnload}>
                    {body}
                </NewWindow>
            ) : ''}
        </Fragment>

    );
};

export default observer(NonModalContainer);
